/** List all tenants. */
export const tenantListSpec = {
    uri: '/t/list',
    method: 'GET',
    adminOnly: true,
};
